module.exports = __webpack_public_path__ + "img/00036.af4234ec.webp";